export default __webpack_public_path__ + "static/media/ReportIcon-MRI-MS.17e60f5e.jpg";